import { HexColorPicker } from 'react-colorful';
import { useRef, useState } from 'react';
import { ColorPickerWrapper, ColorPickerCircle, ColorPickerContainer } from '@styles/InputStyles';
import { useOnClickOutside } from '../hooks/useOnClickOutside';

export interface IColorPickerProps {
  edit?: boolean;
  color: string;
  onChange(color: string): void;
}

export const ColorPicker = ({ edit, color, onChange }: IColorPickerProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [colorState, setColorState] = useState(color);
  const [isOpen, setIsOpen] = useState(false);

  useOnClickOutside(ref, () => setIsOpen(false));

  const handleChange = (color: string) => {
    setColorState(color);
    onChange(color);
  };

  return (
    <ColorPickerWrapper ref={ref}>
      <ColorPickerCircle color={colorState} onClick={() => edit && setIsOpen(true)} />

      {isOpen && (
        <ColorPickerContainer>
          <HexColorPicker color={colorState} onChange={handleChange} />
        </ColorPickerContainer>
      )}
    </ColorPickerWrapper>
  );
};
